export default {
  openButton: 'Generar con IA',
  title: 'Generar {entity} con IA',
  subtitleSetup: 'Paso 1 de 2 · Arma el plan de lo que se va a redactar',
  subtitleReview: 'Paso 2 de 2 · Revisa antes de agregarlas',
  close: 'Cerrar',
  back: 'Volver al plan',
  questionsEntity: 'Preguntas',

  // Paso 1
  fromDesign: 'Del Diseño Instruccional: "{piece}"',
  testScore: '{score} pts',
  themeLabel: 'Tema u orientación (opcional)',
  themePlaceholder: 'Ej: situar las preguntas en el caso de la cadena de frío',
  themeHint: 'Orienta sobre qué situar las preguntas',
  themeInfo:
    'Acota el contexto en el que se sitúan las preguntas, sin cambiar lo que miden: un caso, un escenario o un énfasis. Ej: "a partir de un registro de temperaturas", "en el contexto de una pyme". No es un espacio para dar instrucciones.',
  existingTitle: 'Este Instrumento ya tiene {count} preguntas ({score} pts). El plan parte por lo que falta:',
  coverageCount: '{count} ya',
  coverageNone: 'sin preguntas',
  planTitle: 'Plan de {entity}',
  planHint:
    'Una fila por pregunta: sobre qué {entity} se pregunta, de qué tipo y cuánto vale. Esto es exactamente lo que se va a redactar — la cantidad y el puntaje no los decide la IA.',
  colType: 'Tipo',
  colCorrect: 'Correctas',
  colOptions: 'Alternativas',
  colScore: 'Puntaje',
  addRow: 'Agregar una pregunta al plan',
  removeRow: 'Quitar del plan',
  planEmpty:
    'El plan está vacío. Agrega al menos una pregunta y elige sobre qué {entity} se pregunta.',
  planTotal: 'Total del plan: {total} pts',
  planTotalOf: 'Total del plan: {total} de {score} pts',
  typesDisabled:
    'No se ofrecen {types}: la Situación Evaluativa "{situation}" no las habilita.',
  typeRedaction: 'Desarrollo',
  typeSimpleSelection: 'Selección Simple',
  typeMultipleSelection: 'Selección Múltiple',

  // Paso 2
  streaming: 'Redactando... {done} de {total} listas',
  reviewHint:
    '{count} preguntas propuestas. Ninguna se ha guardado todavía: descarta las que no sirvan y agrega el resto.',
  reviewEmpty: 'No quedó ninguna pregunta para revisar.',
  points: '{score} pts',
  missingRows:
    'La IA no devolvió {count} de las preguntas del plan. Vuelve atrás y genéralas de nuevo si las necesitas.',
  maxWords: 'Largo máximo sugerido: {words} palabras',
  discard: 'Descartar',
  redo: 'Regenerar sólo esta pregunta',
  restore: 'Recuperar',

  // Acciones
  generate: 'Generar {count}',
  save: 'Agregar {count}',
  saved: 'Se agregaron {count} preguntas.',
  savingProgress: 'Guardando... {done} de {total}',

  // Errores
  generateError:
    'Ocurrió un error al generar las preguntas con IA. Intenta nuevamente.',
  generateEmpty:
    'La IA no propuso ninguna pregunta que se pueda puntuar. Intenta nuevamente, o ajusta el plan.',
  noTypesAvailable:
    'La Situación Evaluativa "{situation}" no habilita preguntas en este Instrumento.',
  noDimensions:
    'La Pauta de este Instrumento todavía no tiene {entity} de las que colgar las preguntas. Crea la Pauta primero.',
  noCriterias:
    'Esta evaluación no declara ningún {entity}, que es lo que las preguntas vienen a medir. Decláralos en el Diseño Instruccional y vuelve a intentar.',
}
